import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
// routes
import { PATH_DASHBOARD } from '../routes/paths';

// ----------------------------------------------------------------------

GuestGuard.propTypes = {
  children: PropTypes.node
};

export default function GuestGuard({ children }) {
  const { isAuthenticated } = useAuth();
  const { pathname, search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const type = searchParams.get('type');

  if (isAuthenticated) {
    // if (pathname.includes("auth/register") && type) {
    //   return <>{children}</>;
    // }
    return <Navigate to={PATH_DASHBOARD.root} />;
  }

  return <>{children}</>;
}
